import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import FeedWrapper from './FeedWrapper';
import LoginWrapper from './LoginWrapper';
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userCredentials: {
        username: 'dsymiller',
        password: 'cohortNY22',
        isLoggedIn: false,
      },
    };
    this.handleLogin = this.handleLogin.bind(this);
  }
  handleLogin() {
    this.setState({
      userCredentials: {
        username: 'dsymiller',
        password: 'cohortNY22',
        isLoggedIn: true,
      },
    });
  }
  render() {
    const { username, password, isLoggedIn } = this.state.userCredentials;
    let pageSelector = isLoggedIn ? (
      <FeedWrapper username={username} />
    ) : (
      <LoginWrapper
        username={username}
        password={password}
        handleLogin={this.handleLogin}
      />
    );
    return pageSelector;
  }
}

ReactDOM.render(<App />, document.getElementById('feed-root'));
